<template>
  <view-wrapper>
    <div class="flex flex-col items-center justify-start flex-grow w-full ">
      <div class="flex flex-col w-3/4 mt-3 md:w-1/2" v-if="category && subCategory">
        <p class="font-bold">{{subCategory}}</p>
        <p class="text-sm font-light">{{category}}</p>
      </div>
      <input
        v-model="search"
        class="w-3/4 px-2 py-1 mt-3 mb-8 border border-gray-300 rounded md:w-1/2"
        type="text"
        placeholder="Search"
      >
      <div class="flex flex-row flex-wrap w-full px-8">
        <item
          v-for="(item, key) in filteredItems"
          :key="key"
          :item="item"
          @click.native="$router.push({ name: 'Item', params: { item_id: item.id}})"
          class=""
        />
      </div>
      <div v-if="filteredItems.length === 0 && !loading" class="flex flex-col justify-start flex-grow h-56">
        <p class="text-center">There are no items that match your query</p>
      </div>
      <div v-else-if="loading">
        <p class="text-center"> Loading... </p>
      </div>
    </div>
  </view-wrapper>
</template>

<script>
import ViewWrapper from '../components/ViewWrapper.vue';
import Item from '../components/Items/Item.vue';

const axios = require('axios');

export default {
  name: 'items',
  data() {
    return {
      items: [],
      search: '',
      loading: true,
    };
  },
  components: {
    Item,
    ViewWrapper,
  },
  computed: {
    filteredItems() {
      const search = this.search.toLowerCase().trim();
      return this.items.filter((item) => {
        const name = item.name.toLowerCase().trim();
        if (name.includes(search)) return true;
        return false;
      });
    },
    category() { return 'category' in this.$route.query ? this.$route.query.category : null; },
    subCategory() { return 'subCategory' in this.$route.query ? this.$route.query.subCategory : null; },
  },
  watch: {
    search() {
      this.$router.push({
        name: 'Items',
        query: {
          ...this.$route.query,
          search: this.search,
        },
      });
    },
    $route: {
      handler() {
        this.loadItems();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadItems();
    this.search = this.$route.query.search || '';
  },
  methods: {
    loadItems() {
      axios.get(
        '/api/items',
        {
          params: {
            category: this.category,
            subCategory: this.subCategory,
          },
          headers: { token: 'allow' },
        },
      )
        .then((result) => {
          this.items = result.data;
        })
        .catch(() => {
          console.log('Error in getting the items');
        })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>
